import { render, staticRenderFns } from "./LayerEditor.vue?vue&type=template&id=5af0b385&scoped=true"
import script from "./LayerEditor.vue?vue&type=script&lang=js"
export * from "./LayerEditor.vue?vue&type=script&lang=js"
import style0 from "./LayerEditor.vue?vue&type=style&index=0&id=5af0b385&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0b385",
  null
  
)

export default component.exports